import { ethers } from 'ethers';
import { useNavigate } from 'react-router-dom';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { Flexbox } from '../action/Flexbox';
import SearchBar from '../action/SearchBar';
import ThemeLogo from '../theme/ThemeLogo';

import { useState } from 'react';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { trackClairtyEvent, truncateEthereumAddress } from '../../utils';
import ThemedText from '../theme/ThemedText';
import './Navbar.scss';

const Navbar = () => {
  const [{ user }] = useGlobalState();

  const { userLogout, openLogin } = useLoginHelper();
  const [searchTerm, setSearchTerm] = useState();
  const [searchResult, setSearchResult] = useState();
  const [isHovering, setIsHovering] = useState();
  const history = useNavigate();

  function handleSearch(text) {
    if (!text) return;
    if (ethers.isAddress(text)) {
      setSearchTerm('');
      history(`/profile/${text}/projects`);
    }
  }

  function onMouseEnter() {
    setIsHovering(true);
  }
  function onMouseLeave() {
    setIsHovering(false);
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter' && searchTerm.trim() !== '') {
      handleSearch(searchTerm);
      setSearchResult(null);
    }
  }

  function updateSearch(value) {
    setSearchTerm(value);
    if (ethers.isAddress(value)) {
      setSearchResult([{ name: truncateEthereumAddress(value), address: value }]);
    } else {
      setSearchResult([]);
    }
  }

  function handleSearchClick() {
    if (ethers.isAddress(searchTerm)) {
      setSearchTerm('');
      setSearchResult(null);
      
      trackClairtyEvent('user_profile_visited', {
        origin: 'top_search',
        is_own_profile: Boolean(searchTerm === user?.address),
      });

      history(`/profile/${searchTerm}/projects`);
    }
  }

  function handleRedirect() {
    history(`/profile/${user?.address}/projects`);
  }

  function openWrite() {
    if (!user) return openLogin();
    history('/takes/write');
  }
  return (
    <section className='navbar_container'>
      <Flexbox className='navbar_container__content' justifyContent='space-between'>
        <Flexbox className='navbar_container__content__left' alignItems='center' gap='0.5rem'>
          <ThemeLogo onClick={handleRedirect} className='pointer' icon={'mercle'} />
        </Flexbox>
        <Flexbox alignItems='center' justifyContent='flex-start' gap='0.75rem' className='routes_container'>
          <SearchBar
            placeholder='Search address'
            value={searchTerm}
            onChange={e => updateSearch(e.target.value)}
            handleKeyDown={handleKeyDown}
            style={{ width: '25rem' }}
            searchData={searchResult}
            handleSearchClick={handleSearchClick}
          />

          {/* <NavLink to='/pod' className='route-link' activeclassname='active'>
            <ThemedText.P>Pod</ThemedText.P>
          </NavLink>
          <NavLink to='/profile' className='route-link' activeclassname='active'>
            <ThemedText.P>Profile</ThemedText.P>
          </NavLink>
          <NavLink to='/takes' className='route-link' activeclassname='active'>
            <ThemedText.P>Takes</ThemedText.P>
          </NavLink> */}
          {/* <a href='https://unfair.mercle.ai/' target='_blank' className='route-link unfair' activeclassname='active'>
            Mint Unfair NFT
          </a> */}

          {/* <NavLink to='/explore' className='route-link' activeclassname='active'>
            <ThemedText.P>Explore</ThemedText.P>
          </NavLink> */}

          {/* <Flexbox onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            {isHovering ? <ThemeLogo className={'pointer'} icon={'powerHover'} onClick={userLogout} /> : <ThemeLogo className={'pointer'} icon={'power'} onClick={userLogout} />}
          </Flexbox> */}
          {/* <button className='route-link' onClick={userLogout}>
            Logout
          </button> */}
        </Flexbox>
        <Flexbox gap='0.4rem' className='pointer route-link' onClick={openWrite}>
          <ThemedText.H5>Post Take </ThemedText.H5>
          <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M8 3.33398V12.6673' stroke='#111111' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
            <path d='M3.33203 8H12.6654' stroke='#111111' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
          </svg>
        </Flexbox>
      </Flexbox>
    </section>
  );
};

export default Navbar;
